<template>
    <div>
        <v-combobox
            ref="emailCombo"
            v-model="items"
            multiple
            :outlined="outlined"
            dense
            :label="label"
            small-chips
            hide-selected
            @blur="manualBlur"
            @input="handleInput"
            :deletable-chips="true"
            :counter="items.length > 0"
        >
            <template v-slot:selection="data">
                <v-chip
                    label
                    class="ma-1"
                    :color="invalidItems.includes(data.item) ? 'error' : '#f8f8f8'"
                    small
                    :key="JSON.stringify(data.item)"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                >
                    {{ data.item }}
                    <font-awesome-icon
                        @click.stop="removeItemFromList(data)"
                        class="ml-2 del-btn"
                        icon="fa-regular fa-circle-x"
                    />
                </v-chip>
            </template>
            <template v-slot:no-data>
                <div style="border: 2px transparent">
                    <v-list-item>
                        <v-list-item-content>
                            <div>Press <span class="entr-key">Enter</span> to add email</div>
                        </v-list-item-content>
                    </v-list-item>
                </div>
            </template>
            <template v-slot:counter="{ props }">
                <div v-if="props.value" class="email-counter">{{ props.value }} Recipients</div>
            </template>
        </v-combobox>
    </div>
</template>
<script>
import { mapActions } from 'pinia';
import { useGlobalState } from '@/stores/globalState';
export default {
    data() {
        return {
            items: [],
            invalidItems: [],
        };
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        max: {
            type: Number,
            default: null,
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.items = newVal
                        .split(',')
                        .map(x => x.trim())
                        .filter(x => x !== '');
                    this.checkInvalidEmails();
                } else {
                    this.items = [];
                }
            },
        },
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),
        manualBlur() {
            this.$refs.emailCombo.blur();
        },
        handleInput() {
            if (this.max && this.items.length > this.max) {
                this.handleMaxLimitReached();
                return;
            }

            this.checkInvalidEmails();
            this.$emit('input', this.items.join(','));
        },
        checkInvalidEmails() {
            const filteredContacts = this.filterContacts(this.items);

            this.invalidItems = filteredContacts.invalid;

            this.$emit('invalid', this.invalidItems.length > 0);
        },
        filterContacts(contacts) {
            const validEmails = [];
            const invalid = [];

            contacts.forEach(contact => {
                if (this.isValidEmail(contact)) {
                    validEmails.push(contact);
                } else {
                    invalid.push(contact);
                }
            });

            return {
                validEmails,
                invalid,
            };
        },
        isValidEmail(value) {
            // Source: https://emailregex.com/
            const emailRegex = /\S+@\S+\.\S+/;
            return emailRegex.test(value);
        },
        handleMaxLimitReached() {
            this.showSnackbar({ message: `Please limit entries to ${this.max}`, color: 'error' });
            while (this.items.length > this.max) {
                this.items.pop();
            }
        },
        removeItemFromList(data) {
            this.items.splice(data.index, 1);

            this.checkInvalidEmails();
            this.$emit('input', this.items.join(','));
        },
    },
};
</script>
<style lang=""></style>
